import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

export const getOrganizationWhatsAppConfig = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "organization/whatsapp-config",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load WhatsApp configuration");
};

export const updateOrganizationWhatsAppConfig = async (config) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: "organization/whatsapp-config",
    data: config,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update WhatsApp configuration");
};

export const getAdminOrganizationWhatsAppConfig = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `admin/organizations/${organizationId}/whatsapp-config`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load WhatsApp configuration");
};

export const updateAdminOrganizationWhatsAppConfig = async (organizationId, config) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `admin/organizations/${organizationId}/whatsapp-config`,
    data: config,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update WhatsApp configuration");
};
